export default function FranceText({ className = "" }) {
  return (
    <span className={className}>
      <span style={{ color: '#002395' }}>Fr</span>
      <span style={{ color: '#FFFFFF', textShadow: '0 0 1px #000' }}>an</span>
      <span style={{ color: '#ED2939' }}>ce</span>
    </span>
  );
}
